export default __webpack_public_path__ + "static/16-9d47f3256618b2bb72c8acfde8fddd3e.jpg";